import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../../cssfiles/loginpage.css";
import "../../cssfiles/homepage.css";
import Loginpageleftimage from "../../pages/Loginpageleftimage.js";
import brandlogo from "../../images/LKLogo.png";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import {
  FormControl,
  Input,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { ValidateResetToken, ResetPassword } from "../../Restclient/datacollection.js";

export default function ResetPasswordPage() {
  const [email, setEmail] = useState(""); // prefilled email from URL
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("Info");

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const emailFromURL = searchParams.get("email") || "";
  const navigate = useNavigate();
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  // Password validation
  const isPasswordValid = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,30}$/;
    return regex.test(password);
  };

  const handleCloseDialog = () => setOpenDialog(false);
  const handleConfirmDialog = () => setOpenDialog(false);

 
  useEffect(() => {
    const validateToken = async () => {
      if (!token || !emailFromURL) return;

      try {
        const res = await ValidateResetToken(token, emailFromURL);
        if (!res.valid) {
          setDialogMessage("This reset link has expired or has already been used.");
          setDialogType("Error");
          setOpenDialog(true);
        } else {
          setEmail(emailFromURL); // prefill email field
        }
      } catch (err) {
        console.error(err);
        setDialogMessage("Invalid or expired reset link.");
        setDialogType("Error");
        setOpenDialog(true);
      }
    };
    validateToken();
  }, [token, emailFromURL]);

 
  const handleSubmit = async () => {
    if (!email || !token) {
      setDialogMessage("Invalid reset link or missing email.");
      setDialogType("Error");
      setOpenDialog(true);
      return;
    }

    if (!isPasswordValid(newPassword)) {
      setDialogMessage(
        "Password must contain upper, lower, digit, special character and 8-30 chars."
      );
      setDialogType("Error");
      setOpenDialog(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setDialogMessage("Passwords do not match.");
      setDialogType("Error");
      setOpenDialog(true);
      return;
    }

    try {
      const response = await ResetPassword(email, token, newPassword, confirmPassword);
      if (response.success) {
        setDialogMessage("Password reset successfully!");
        setDialogType("Success");
        setOpenDialog(true);
        // redirect after short delay
        setTimeout(() => navigate("/"), 2000);
      } else {
        setDialogMessage(response.message || "Password reset failed.");
        setDialogType("Error");
        setOpenDialog(true);
      }
    } catch (err) {
      console.error(err);
      setDialogMessage("Something went wrong.");
      setDialogType("Error");
      setOpenDialog(true);
    }
  };

  return (
    <div className="container">
      <div className="left-side">
        <Loginpageleftimage />
      </div>

      <div className="right-side">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flexGrow: 1 }}></div>
          <div className="formcompanylogo">
            <img
              src={brandlogo}
              alt="logo"
              style={{ marginLeft: "17px", height: "55px", width: "150px" }}
            />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "row", marginTop: "50px" }}>
          <div style={{ flexGrow: 1 }}></div>
          <div className="loginarea">
            <Typography
              className="signintext"
              style={{ fontSize: "30px", fontWeight: 700, marginBottom: "25px" }}
            >
              Reset Password
            </Typography>

            {/* Email (disabled) */}
            <div style={{ marginBottom: "25px" }}>
              <label style={{ fontSize: "18px", fontWeight: 400, color: "#3C3C3C" }}>
                Email ID <span style={{ color: "red" }}>*</span>
              </label>
              <FormControl sx={{ m: 1, width: "358px" }} variant="standard">
                <Input id="email" type="email" value={email} disabled />
              </FormControl>
            </div>

            {/* New Password */}
            <div style={{ marginBottom: "25px" }}>
              <label style={{ fontSize: "18px", fontWeight: 400, color: "#3C3C3C" }}>
                Enter New Password <span style={{ color: "red" }}>*</span>
              </label>
              <FormControl sx={{ m: 1, width: "358px" }} variant="standard">
                <Input
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility}>
                        {showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            {/* Confirm Password */}
            <div style={{ marginBottom: "25px" }}>
              <label style={{ fontSize: "18px", fontWeight: 400, color: "#3C3C3C" }}>
                Confirm Password <span style={{ color: "red" }}>*</span>
              </label>
              <FormControl sx={{ m: 1, width: "358px" }} variant="standard">
                <Input
                  type={showPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility}>
                        {showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div style={{ marginTop: "20px", width: "250px" }}>
              <button
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "35px",
                  fontSize: "18px",
                  backgroundColor: "#005C8E",
                  color: "#FFFFFF",
                  cursor: "pointer",
                  border: "none",
                  borderRadius: "25px",
                }}
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Dialog */}
      <CustomDialogBox
        dialogTitle={dialogType}
        dialogText={dialogMessage}
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleConfirmDialog={handleConfirmDialog}
        confirmText={"OK"}
        type={dialogType}
      />
    </div>
  );
}
